<script>import { cfgToThemeCdnPath } from "@infinitro/config";
import { closeThisModal, ModalDialog, stateOpenModal } from "@infinitro/global";
import { Modal } from "@infinitro/modal";
import LuckyWheel from "./parts/lucky-wheel.svelte";
export const thisModal = ModalDialog.LuckyDip;
const closeModal = () => closeThisModal(thisModal);
const stars = [
  { top: 12, left: 18, scale: 0.8, opacity: 0.7, rotation: -20 },
  { top: 6, right: 10, scale: 0.7, opacity: 0.8, rotation: -30 },
  { top: 14, right: 22, scale: 0.9, opacity: 0.95, rotation: 60 },
  { bottom: 8, left: 12, scale: 0.75, opacity: 0.85, rotation: -15 },
  { bottom: 6, right: 8, scale: 0.85, opacity: 0.9, rotation: -45 }
];
function getPositionStyle(star) {
  const positions = [];
  if (star.top !== void 0) positions.push(`top:${star.top}%`);
  if (star.bottom !== void 0) positions.push(`bottom:${star.bottom}%`);
  if (star.left !== void 0) positions.push(`left:${star.left}%`);
  if (star.right !== void 0) positions.push(`right:${star.right}%`);
  return `${positions.join(";")};transform:translate(-50%,-50%) scale(${star.scale}) rotate(${star.rotation}deg);opacity:${star.opacity};`;
}
</script>

{#if $stateOpenModal === thisModal}
	<div class="lucky-dip-modal">
		<Modal
			width={'851px'}
			height={'484px'}
			{closeModal}
			padding="0"
			customStyle="border-color: var(--color-secondary-500) !important;"
			customStyleContent="padding: 0;"
		>
			<div class="modal-content">
				<div class="stars-layer">
					{#each stars as star, i}
						<img
							src={cfgToThemeCdnPath(`/lucky-dip/star.svg`)}
							alt="star"
							class="star"
							style={getPositionStyle(star)}
						/>
					{/each}
				</div>
				<LuckyWheel {closeModal} />
			</div>
		</Modal>
	</div>
{/if}

<style>
	.lucky-dip-modal :global(.modal) {
		position: relative;
		background-image: none !important;
	}

	.lucky-dip-modal :global(.modal)::before {
		content: '';
		position: absolute;
		inset: 0;
		background: linear-gradient(
			180deg,
			var(--color-secondary-500) 0%,
			var(--color-secondary-700) 100%
		);
		border-radius: inherit;
		z-index: 0;
		pointer-events: none;
	}

	.lucky-dip-modal :global(.modal > *) {
		position: relative;
		z-index: 1;
	}

	.stars-layer {
		position: absolute;
		inset: 0px;
		z-index: 10;
		pointer-events: none;
}

	.star {
		position: absolute;
		width: 16px;
		height: 16px;
}

	.modal-content {
		height: 100%;
		width: 100%;
}
</style>
